/**
 * [Insider+] Auth-failure recovery modal for the iframe.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import i18next from 'i18next';
import Modal from '../../Modal/Modal';
import ModalBody from '../../Modal/ModalBody';
import Paragraph from '../../Paragraph/Paragraph';
import ModalButtons from '../../Modal/ModalButtons';
import { selectSupportEmail } from '../../../store/selectors/settingsSelectors';

const InsiderPlusAuthModal = ({ isOpen, isRetrying, onRetry }) => {
  const supportEmail = useSelector(selectSupportEmail);

  return (
    <Modal
      title={i18next.t('insiderPlus.authModal.title')}
      isOpen={isOpen}
      size="sm"
      handleOutsideClick={false}
    >
      <ModalBody>
        <Paragraph marginBottom={16}>
          {i18next.t('insiderPlus.authModal.body')}
        </Paragraph>
        <ModalButtons
          isVertical
          marginTop
          primaryButtonProps={{
            label: i18next.t('insiderPlus.authModal.tryAgain'),
            onClick: onRetry,
            disabled: isRetrying,
          }}
          secondaryButtonProps={{
            label: i18next.t('insiderPlus.authModal.refresh'),
            onClick: () => window.location.reload(),
            disabled: isRetrying,
          }}
        />
        <Paragraph centerText marginTop={16} fontSize={14}>
          {i18next.t('insiderPlus.authModal.contactSupportPrefix')}{' '}
          {supportEmail ? (
            <a href={`mailto:${supportEmail}`}>
              {i18next.t('insiderPlus.authModal.contactSupportLink')}
            </a>
          ) : (
            i18next.t('insiderPlus.authModal.contactSupportLink')
          )}
          .
        </Paragraph>
      </ModalBody>
    </Modal>
  );
};

InsiderPlusAuthModal.propTypes = {
  isOpen: PropTypes.bool,
  isRetrying: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
};

export default InsiderPlusAuthModal;
